import { Component } from '@angular/core';
import { SharedModule } from './shared/shared.module';
import { NotificationPopupComponent } from './components/notification-popup/notification-popup.component';
import { GlobalLoaderComponent } from './components/global-loader/global-loader.component';
import { NotificationService } from './shared/services/notification.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [SharedModule, NotificationPopupComponent, GlobalLoaderComponent],
})
export class AppComponent {
  constructor(
    public notificationService: NotificationService
  ) {}
}
